var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H39.9791V23.9973H0V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9904 14.391V23.9973H21.9888V14.391H39.9792V9.5936H21.9888V0H17.9904V9.5936H0V14.391H17.9904Z",
    fill: "#CF142B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.322 7.76784V0H36.266L23.322 7.76784ZM23.322 16.2293V23.9973H36.266L23.322 16.2293ZM16.6571 16.2293V23.9973H3.71319L16.6571 16.2293ZM16.6571 7.76784V0H3.71319L16.6571 7.76784ZM0.00012207 2.23072V7.99888H9.61172L0.00012207 2.23072ZM39.9791 2.23072V7.99888H30.3675L39.9791 2.23072ZM39.9791 21.7666V15.9984H30.3675L39.9791 21.7666ZM0.00012207 21.7666V15.9984H9.61172L0.00012207 21.7666Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9791 0H37.7585L24.4533 7.99888H26.6739L40 0M15.5257 15.9979H13.3052L0 23.9968H2.22053L15.5467 15.9979M11.1024 8.00512H13.3228L0 0V1.3416L11.1024 8.00512ZM28.8697 15.9949H26.6492L39.972 24V22.6584L28.8697 15.9949Z",
    fill: "#CF142B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 23,
    rx: 3.5,
    stroke: "#F4EBE7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.55ba6c81ee0237b6fe0d2b37a18dcda0.svg";
export { ForwardRef as ReactComponent };